export interface Question {
  id: number;
  text: string;
  microcopy: string;
  options: {
    text: string;
    value: number;
  }[];
}

export const questions: Question[] = [
  {
    id: 1,
    microcopy: "Lad os starte her",
    text: "Hvor ofte føler du, at du har tid til de opgaver og prioriteringer på arbejdet, der er vigtige for dig?",
    options: [
      { text: "Sjældent eller aldrig", value: 0 },
      { text: "En gang imellem", value: 1 },
      { text: "Ofte eller altid", value: 2 },
    ],
  },
  {
    id: 2,
    microcopy: "Tænk over din hverdag",
    text: "Hvor godt lykkes det dig at holde regelmæssige pauser i løbet af din arbejdsdag?",
    options: [
      { text: "Det glemmer jeg ofte", value: 0 },
      { text: "Nogle gange lykkes det", value: 1 },
      { text: "Jeg prioriterer mine pauser", value: 2 },
    ],
  },
  {
    id: 3,
    microcopy: "Når arbejdsdagen er slut",
    text: "Hvordan går det med at koble helt af fra arbejdet, når din arbejdsdag er slut?",
    options: [
      { text: "Svært – tankerne kører videre", value: 0 },
      { text: "Det går okay, men tager tid", value: 1 },
      { text: "Jeg kan let skifte fokus", value: 2 },
    ],
  },
  {
    id: 4,
    microcopy: "Din energi",
    text: "Hvor meget energi har du typisk sidst på dagen?",
    options: [
      { text: "Jeg er helt tom", value: 0 },
      { text: "jeg er lidt træt, men det går", value: 1 },
      { text: "Jeg har stadig overskud", value: 2 },
    ],
  },
  {
    id: 5,
    microcopy: "Relationer og nærvær",
    text: "Har du energi tilbage efter arbejdet til de mennesker, der betyder noget for dig?",
    options: [
      { text: "Sjældent – jeg har ikke meget at give", value: 0 },
      { text: "Nogle dage er bedre end andre", value: 1 },
      { text: "Ja, det prioriterer jeg", value: 2 },
    ],
  },
  {
    id: 6,
    microcopy: "Dit generelle velbefindende",
    text: "Hvordan oplever du balancen mellem dit arbejde og dit privatliv lige nu?",
    options: [
      { text: "Det føles skævt og presset", value: 0 },
      { text: "Det kunne være bedre", value: 1 },
      { text: "Det er i god balance", value: 2 },
    ],
  },
];

export interface Advice {
  icon: string;
  title: string;
  why: string;
  actions: string[];
}

export const lowBalanceAdvice: Advice[] = [
  {
    icon: "Heart",
    title: "Start med dig selv",
    why: "Når du er langt nede, skal du bygge op igen – et lille skridt ad gangen.",
    actions: [
      "Find 10 minutter i dag til noget, der giver ro",
      "Sig nej til én ting, der tapper dig for energi",
      "Bed om hjælp – det er styrke, ikke svaghed",
    ],
  },
  {
    icon: "Coffee",
    title: "Pauser er ikke luksus",
    why: "Din krop og hjerne har brug for genopladning.",
    actions: [
      "Sæt en timer: Hver 90. minut – rejs dig og træk vejret",
      "Spis frokost væk fra skærmen",
      "Gå en kort tur, hvis du kan",
    ],
  },
  {
    icon: "Moon",
    title: "Beskyt din søvn",
    why: "Uden søvn bliver alt sværere.",
    actions: [
      "Sluk skærme 30 min før sengetid",
      "Gå i seng på samme tid hver dag",
      "Skab en aften-rutine, der signalerer ro",
    ],
  },
  {
    icon: "Users",
    title: "Du behøver ikke klare det alene",
    why: "Fællesskab giver støtte, og det er okay at læne dig op ad andre.",
    actions: [
      "Del dine tanker med én du stoler på",
      "Overvej professionel hjælp, hvis det føles tungt",
      "Husk: At tale om det er det første skridt",
    ],
  },
  {
    icon: "AlertCircle",
    title: "Sig fra, inden det bliver for meget",
    why: "Du kan ikke være alt for alle – heller ikke for dig selv.",
    actions: [
      "Øv dig i at sige: 'Lige nu har jeg ikke kapacitet'",
      "Prioriter efter vigtighed, ikke hastighed",
      "Lav en liste over, hvad der SKAL ske – resten kan vente",
    ],
  },
];

export const mediumBalanceAdvice: Advice[] = [
  {
    icon: "Battery",
    title: "Genoplad regelmæssigt",
    why: "Små justeringer nu kan forebygge større udfordringer senere.",
    actions: [
      "Book tid til pauser i kalenderen",
      "Find én aktivitet der giver dig energi – og gør den fast",
      "Tjek ind med dig selv én gang om ugen",
    ],
  },
  {
    icon: "Compass",
    title: "Find din balance-rutine",
    why: "Struktur hjælper dig med at holde kursen.",
    actions: [
      "Fastlæg en start- og slut-rutine for arbejdsdagen",
      "Lav en grænse mellem arbejde og fritid",
      "Eksperimenter med, hvad der virker for dig",
    ],
  },
  {
    icon: "Target",
    title: "Prioriter bevidst",
    why: "Ikke alt er lige vigtigt – vælg det, der betyder noget.",
    actions: [
      "Spørg dig selv: Hvad giver mig mest værdi?",
      "Drop perfektionisme – godt nok er godt nok",
      "Lær at sige nej til det, der ikke passer ind",
    ],
  },
  {
    icon: "Smile",
    title: "Giv plads til glæde",
    why: "Balance handler ikke kun om pligter – men også om livskvalitet.",
    actions: [
      "Gør noget, der får dig til at grine",
      "Planlæg én ting om ugen, du glæder dig til",
      "Vær til stede i øjeblikket",
    ],
  },
  {
    icon: "TrendingUp",
    title: "Byg videre på det, der virker",
    why: "Du har allerede gode vaner – styrk dem.",
    actions: [
      "Reflekter over, hvad der giver dig balance",
      "Gentag de ting, der fungerer",
      "Juster løbende, hvis noget ændrer sig",
    ],
  },
];

export const highBalanceAdvice: Advice[] = [
  {
    icon: "Sparkles",
    title: "Bevar dine gode vaner",
    why: "Du har skabt en god balance – værn om den.",
    actions: [
      "Hold fast i de rutiner, der virker",
      "Vær opmærksom på tegn på ubalance",
      "Juster, hvis livet ændrer sig",
    ],
  },
  {
    icon: "Rocket",
    title: "Udforsk og udvikl",
    why: "Balance giver overskud til at prøve nyt.",
    actions: [
      "Udfordr dig selv på nye måder",
      "Prøv noget, du altid har haft lyst til",
      "Invester i personlig udvikling",
    ],
  },
  {
    icon: "Gift",
    title: "Del dine erfaringer",
    why: "Din balance kan inspirere andre.",
    actions: [
      "Fortæl andre, hvad der virker for dig",
      "Vær en god rollemodel",
      "Støt kollegaer eller venner i deres rejse",
    ],
  },
  {
    icon: "Shield",
    title: "Beskyt din balance",
    why: "Det er lettere at bevare end at genopbygge.",
    actions: [
      "Vær opmærksom på forandringer i dit liv",
      "Sæt grænser, når du har brug for det",
      "Husk: Balance kræver vedligeholdelse",
    ],
  },
  {
    icon: "Sun",
    title: "Nyd det, du har skabt",
    why: "Tag dig tid til at værdsætte din rejse.",
    actions: [
      "Vær stolt af, hvor du er",
      "Fejr små sejre",
      "Værdsæt øjeblikket",
    ],
  },
];
